import React from 'react';
import { CompassIcon, LayersIcon, MessageSquareQuoteIcon, MusicIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { volumes, type VolumeIcon } from '../data/volumes';
import { Eyebrow } from './Eyebrow';
const icons: Record<VolumeIcon, React.ElementType> = {
  method: CompassIcon,
  rhythm: MusicIcon,
  harmony: LayersIcon,
  language: MessageSquareQuoteIcon,
  improv: SparklesIcon,
  jam: UsersIcon
};
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-398" data-mp="1zt8fzu358jef">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-399" data-mp="24s1rxi2s82ch">
        <div className="max-w-2xl" data-id="element-400" data-mp="1qtbl3aq5uoax">
          <Eyebrow data-id="element-401" data-mp="1qwha6pyshq6n">Kompletny system</Eyebrow>
          <h2 id="volumes-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-402" data-mp="1vsy6w8k21cvc">
            Sześć <span className="text-amber" data-id="element-403" data-mp="fhar9hefw9ob">tomów</span>
          </h2>
        </div>
        <ol className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-404" data-mp="kfvrhgtoytcr">
          {volumes.map(volume => {
          const Icon = icons[volume.icon];
          return <li key={volume.number} className="flex flex-col rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-7" data-id="element-405" data-mp="3jadhrnirt6af">
                <div className="flex items-center gap-4" data-id="element-406" data-mp="3t6q9wgyo3c32">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg" style={{
                backgroundColor: volume.accent
              }} data-id="element-407" data-mp="3t9ci8itdtvmc">
                    <Icon className="h-5 w-5 text-cream" aria-hidden="true" data-id="element-408" data-mp="60pl2f81lxz1" />
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-409" data-mp="ktao29v3tat1">
                    Tom {volume.number}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-2xl leading-tight text-cream" data-id="element-410" data-mp="tsea9mpki6br">{volume.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-cream-soft" data-id="element-411" data-mp="pog8134y4feh">{volume.description}</p>
                <p className="mt-auto pt-6 text-xs font-semibold leading-relaxed text-cream" data-id="element-412" data-mp="wrmr7u3xiznw">
                  {volume.contents.join(' · ')}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}